import React, { useReducer } from "react";
import { Grid } from "@mui/material";
import NoFooterLayout from "src/components/core/NoFooterLayout";
import MarketTreeMap from "src/components/markets/Charts/Treemap/MarketTreeMap";
import MarketsDisclaimer from "src/components/disclosures/MarketsDisclaimer";
import { MarketTreeMapStyle } from "src/components/markets/Charts/Treemap/MarketTreeMap.styles";

const Treemap = () => {
  const [useDefaultTheme, toggle] = useReducer((theme: any) => !theme, true);
  // ------------------Style Sheet---------------------------
  const classes = MarketTreeMapStyle();
  return (
    <NoFooterLayout toggleTheme={toggle} useDefaultTheme={useDefaultTheme} back eye>
      <Grid container className={classes.container}>
        <Grid item xs={12} md={11}>
          <MarketTreeMap />
          {/* UK-only general information disclaimer */}
          <MarketsDisclaimer />
        </Grid>
      </Grid>
    </NoFooterLayout>
  );
};

export default Treemap;
